/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable @typescript-eslint/unbound-method */
import { PayloadAction } from '@reduxjs/toolkit';
import { actions } from 'Slice/DocumentHubSlice';
import { actions as flurryActions } from 'Slice/HelperSlice';
import {
  DocumentDeleteRequest, DocumentsRequest, RenameDocumentRequest, UploadRequest,
} from 'Types/RequestBodies';
import {
  API, DOCUMENT_DELETE_FAIL, DOCUMENT_DELETE_SUCCESS, DOCUMENT_RENAME_FAIL,
  DOCUMENT_RENAME_SUCCESS, FILE_UPLOAD_ERROR,
} from 'Utils/Constants';
import {
  call, put, takeEvery, takeLatest,
} from 'redux-saga/effects';
import axios from 'Utils/Axios';
import { Document, DocumentsResponse, UploadResponse } from 'Types/DocumentHubTypes';
import { GlobalResponse } from 'Types/ResponseBodies';
import { getFileSize } from 'Utils/UtilityFunctions';

export function* getDocuments(dispatched: PayloadAction<DocumentsRequest>) {
  try {
    const response: DocumentsResponse = yield call(
      axios.post,
      API.GET_DOCUMENTS,
      dispatched?.payload,
    );
    if (response?.status === true) {
      const {
        companyLogo, companyName, chatgptAllowed, data,
      } = response.response;
      if (dispatched.payload.offset === 0) {
        yield put(actions.setHubCompany({ companyLogo, companyName, chatgptAllowed }));
      }
      yield put(actions.setDocuments(data));
    } else {
      yield put(actions.setDocuments([]));
    }
  } catch (err) {
    console.log(err);
  }
}

export function* uploadDocument(dispatched: PayloadAction<UploadRequest>) {
  try {
    const response: UploadResponse = yield call(
      axios.post,
      API.UPLOAD_DOCUMENT,
      dispatched?.payload,
    );
    const file = response?.response?.data[0];
    if (response?.status === true) {
      yield put(actions.documentUploaded(file));
      if (file.uploaded === 1) {
        yield put(actions.setSuccessDocuments(file));
      } else {
        yield put(actions.setFailDocuments({
          name: file.fileName,
          size: file.fileSize,
          failReason: FILE_UPLOAD_ERROR,
        }));
      }
    } else {
      yield put(actions.documentUploaded({} as Document));
      const uploadFile = dispatched?.payload.file;
      yield put(actions.setFailDocuments({
        name: uploadFile ? uploadFile?.name : file?.fileName,
        size: uploadFile ? getFileSize(uploadFile?.size) : '',
        failReason: FILE_UPLOAD_ERROR,
      }));
    }
    yield put(actions.removeUploadDocument());
    yield put(actions.setUploadLink(''));
  } catch (err) {
    console.log(err);
  }
}

export function* deleteDocument(dispatched: PayloadAction<DocumentDeleteRequest>) {
  try {
    const response: GlobalResponse = yield call(
      axios.post,
      API.DELETE_DOCUMENT,
      dispatched?.payload,
    );
    const { id } = dispatched.payload;
    if (response?.status === true) {
      yield put(actions.documentDeleted(id));
      yield put(flurryActions.setNotification({
        message: DOCUMENT_DELETE_SUCCESS,
        proTip: false,
        rightPlacement: false,
        groupId: 0,
        classnameFlag: true,
      }));
    } else {
      yield put(actions.documentDeleteFail(id));
      yield put(flurryActions.setNotification({
        message: DOCUMENT_DELETE_FAIL,
        proTip: false,
        rightPlacement: false,
        groupId: 0,
        classnameFlag: false,
      }));
    }
  } catch (err) {
    console.log(err);
  }
}
export function* renameDocument(dispatched: PayloadAction<RenameDocumentRequest>) {
  try {
    const { payload } = dispatched;
    const response: UploadResponse = yield call(
      axios.post,
      API.RENAME_DOCUMENT,
      payload,
    );
    const file = response?.response?.data[0];
    if (response?.status === true) {
      yield put(actions.documentRenamed(file));
      yield put(flurryActions.setNotification({
        message: DOCUMENT_RENAME_SUCCESS,
        proTip: false,
        rightPlacement: false,
        groupId: 0,
        classnameFlag: true,
      }));
    } else {
      yield put(flurryActions.setNotification({
        message: DOCUMENT_RENAME_FAIL,
        proTip: false,
        rightPlacement: false,
        groupId: 0,
        classnameFlag: false,
      }));
    }
  } catch (err) {
    console.log(err);
  }
}

export function* DocumentHubSaga() {
  yield takeLatest(actions.getDocuments.type, getDocuments);
  yield takeLatest(actions.uploadDocument.type, uploadDocument);
  yield takeEvery(actions.deleteDocument.type, deleteDocument);
  yield takeLatest(actions.renameDocument, renameDocument);
}
